export const RedirectPage = (link) => {
    window.open(link, '_blank');
}